import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import {Button, Tooltip} from "@mui/material";
import {materialWarehouseStatuses} from "../../../../../data/MaterialWarehouseState";
import ModalConfirm from "../../../modal/ModalConfirm";
import ModalAddMaterialRetailIssuingEdge from "./ModalAddMaterialRetailIssuingEdge";
import {Link} from "react-router-dom";
import IssuingEdgeService from "../../../../../API/orders/prodaction.issueedge/issueedge/IssuingEdgeService";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";

const IssuingEdgeWareHouseTable = ({
                                       data,
                                       setData,
                                       idIssuingEdge,
                                       change,
                                       setChange,
                                       tableOptions,
                                       tableOptionsHandle,
                                       handleModalAlert,
                                       id,
                                       number
                                   }) => {

        const [confirmIssueModalOpen, setConfirmIssueModalOpen] = useState(false);
        const [modalAddMaterialRetailIssuingEdgeOpen, setModalAddMaterialRetailIssuingEdgeOpen] = useState(false);
        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);

        const [selectedRows, setSelectedRows] = useState([]);
        const [selectedIds, setSelectedIds] = useState([]);
        const [rowSelection, setRowSelection] = useState({});

        const [availability, setAvailability] = useState({});
        const [issue, setIssue] = useState({});
        const [confirmModalOpen, setConfirmModalOpen] = useState(false);

        const handleSubmitConfirmIssue = () => {

            IssuingEdgeService.issuanceEdgeByIds(idIssuingEdge, selectedIds).then(function () {
                setChange(!change)
                setConfirmIssueModalOpen(false);
                handleModalAlert("Выдача подтверждена", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }

        const getColor = (row) => {
            if (row.original.free < 0) {
                return (theme) => theme.palette.error.main;
            } else {
                if (row.original.availabilityQuantity === 0) {
                    return (theme) => theme.palette.error.main;
                } else {
                    if (row.original.currentIssueReserve === 0 && row.original.free === 0) {
                        return (theme) => theme.palette.error.main;
                    } else {
                        if (row.original.currentIssueReserve >= 0 && row.original.free === 0 && row.original.otherIssueReserve > 0 && row.original.totalIssued > row.original.currentIssueReserve) {
                            return (theme) => theme.palette.error.main;
                        } else {
                            if (row.original.currentIssueReserve >= 0 && row.original.free >= 0 && row.original.otherIssueReserve > 0) {
                                return (theme) => theme.palette.pencil.main;
                            } else {
                                if (row.original.quantity !== row.original.availabilityQuantity) {
                                    return (theme) => theme.palette.pencil.main;
                                } else {
                                    if (row.original.currentIssueReserve >= 0 && row.original.free >= 0 && row.original.otherIssueReserve === 0) {
                                        return (theme) => theme.palette.success.main;
                                    } else {
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        const handleCloseConfirmIssue = () => {
            setConfirmIssueModalOpen(false)
        };

        const handleCloseModalAddMaterialRetailIssuingEdge = () => {
            setModalAddMaterialRetailIssuingEdgeOpen(false)
        };

        const openRetailIssue = useCallback(
            (row) => {
                const subtractSumIssueOtherReserve = row.otherIssueReserve - row.sumIssueOtherReserve
                const currentAvailability = row.availabilityQuantity - subtractSumIssueOtherReserve;
                const currentIssue = currentAvailability - row.free;
                setCurrentEditRowData(row);
                setCurrentEditRowId(row.id);
                setAvailability(currentAvailability)
                setIssue(currentIssue)
                setModalAddMaterialRetailIssuingEdgeOpen(true);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const handleSubmitConfirmRetailIssue = (value) => {

            IssuingEdgeService.issuanceEdgeRetail(currentEditRowData.id, value, idIssuingEdge).then(function () {
                setChange(!change)
                handleCloseModalAddMaterialRetailIssuingEdge();
                handleModalAlert("Материал выдан", 'success')
            })
                .catch(function (error) {
                    handleModalAlert(error);
                });
        }


        const columns = useMemo(() => {

            const baseColumns = [
                {
                    id: 'nameMaterial',
                    header: 'Наименование',
                    accessorKey: 'nameMaterial',
                    minSize: 10,
                    maxSize: 10,
                },
                {
                    id: 'quantity',
                    header: 'Кол.',
                    accessorKey: 'quantity',
                    minSize: 10,
                    maxSize: 10,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        const color = getColor(row);
                        return (
                            <Box sx={{color: color}}>
                                {value === null || value === undefined ? 'Ожидание' : value.toFixed(2)}
                            </Box>
                        );
                    },
                },
                {
                    id: 'availabilityQuantity',
                    header: 'Нал.',
                    accessorKey: 'availabilityQuantity',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                    },
                },
                {
                    id: 'currentIssueReserve',
                    accessorKey: 'currentIssueReserve',
                    size: 8,
                    maxSize: 8,
                    header: 'Тек. выд.',
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : value.toFixed(2)
                    },
                },
                {
                    id: 'inReserve',
                    accessorKey: 'inReserve',
                    size: 8,
                    maxSize: 8,
                    header: 'В резерве',
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : <Link
                            to={'/organization/issuing-edges/' + id + '/' + number + '/' + row.original.id}>{value.toFixed(2)}</Link>
                    },
                },
                {
                    id: 'free',
                    header: 'Своб.',
                    accessorKey: 'free',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return <Box sx={{
                            color: (theme) => value > 0 ? theme.palette.success.main : "black"
                        }}>{value === null || value === undefined ? 'Ожидание' : value.toFixed(2)}</Box>
                    }
                },
                {
                    id: 'otherIssueReserve',
                    header: 'Проч. выд.',
                    accessorKey: 'otherIssueReserve',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell}) => {
                        const value = cell.getValue();
                        return value === null || value === undefined ? 'Ожидание' : value.toFixed(3)
                    },
                },
                {
                    id: 'sumIssueCurrent',
                    header: 'Выдано в текущем',
                    accessorKey: 'sumIssueCurrent',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return <Link
                            to={'/organization/' + idIssuingEdge + '/issuance-warehouse-material/' + row.original.id}>{value === null || value === undefined ? 0 : value.toFixed(2)}</Link>
                    },
                },
                {
                    id: 'totalIssued',
                    header: 'Выд. всего',
                    accessorKey: 'totalIssued',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell, row}) => {
                        const value = cell.getValue();
                        return <Link
                            to={'/organization/issuance-warehouse-material/' + row.original.id}>{value === null || value === undefined ? 0 : value.toFixed(2)}</Link>
                    },
                },
                {
                    id: 'overspending',
                    header: 'Перерасход',
                    accessorKey: 'overspending',
                    size: 8,
                    maxSize: 8,
                },
                {
                    id: 'materialWarehouseState',
                    header: 'Статус',
                    accessorKey: 'materialWarehouseState',
                    size: 8,
                    maxSize: 8,
                    Cell: ({cell}) => materialWarehouseStatuses[cell.getValue()],
                    filterFn: (row, id, filterValue) => {
                        return materialWarehouseStatuses[row.original.materialWarehouseState].toLowerCase().includes(filterValue.toLowerCase())
                    },
                },
                {
                    header: 'id',
                    id: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    enableHiding: false,
                },
                {
                    id: 'warehouse',
                    header: 'Склад',
                    accessorKey: 'warehouse',
                    size: 8,
                    maxSize: 8,
                    enableEditing: false,
                    Cell: ({cell, row}) => row.original.warehouse === null ? '' : cell.getValue(),
                },
                {
                    id: 'note',
                    header: 'Ком.',
                    accessorKey: 'note',
                    size: 8,
                    maxSize: 8,
                },
            ];

            return baseColumns;

        }, [data, setData,]);
        const handleToArchive = (row) => {
            setCurrentEditRowData(row);
            setConfirmModalOpen(true);
        }
        const handleCloseConfirm = () => {
            setConfirmModalOpen(false);
            setCurrentEditRowData(null)
        };
        const handleSubmitConfirm = () => {
            MaterialWarehouseService.sendToArchive(currentEditRowData?.id)
                .then(function () {
                    handleCloseConfirm()
                    setData(prev => prev.filter(el => currentEditRowData?.id !== el.id))
                    tableOptionsHandle({...tableOptions, totalElements: data?.length - 1})
                    handleModalAlert("Данные отправлены в архив", 'success')
                })
                .catch(function (error) {
                    handleModalAlert(error);
                })
        };
        const menuItem = [
            {type: "add", text: "Выдать штучно", handler: openRetailIssue},
            {type: "archive", text: "Поместить в архив", handler: handleToArchive},
        ]

        return (
            <div>
                <MaterialReactTable
                    renderTopToolbar={({table}) => {
                        return <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "7px",
                            backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                        }}>
                            <MRT_ToolbarAlertBanner table={table}/>
                            <Box sx={{display: "flex"}}>
                                <MRT_ToggleFiltersButton table={table}/>
                                <MRT_GlobalFilterTextField table={table}/>
                            </Box>
                        </Box>
                    }}
                    selectAllMode={"all"}
                    muiTableBodyCellProps={{
                        sx: {
                            p: '0px 0px 0px 10px',
                            m: '0px 0px 0px 0px',
                            border: "none",
                            "&:after": {
                                display: "none",
                            },
                            "&:not(:last-of-type)": {
                                borderRight: '1px solid #EAEBEA',

                            },
                            "& a": {
                                color: "#006CCC",
                                textDecoration: "none",
                                "&:hover": {
                                    textDecoration: "underline"
                                }
                            },

                        },
                    }}
                    muiTableHeadCellProps={{
                        sx: {
                            border: '1px solid #EAEBEA',
                            backgroundColor: "#F5F6FA",
                            padding: "10px",
                            paddingBottom: " 0.2rem",
                            paddingTop: "0.2rem"
                        },
                    }}
                    muiTableBodyRowProps={({row}) => {
                        return ({
                            sx: () => ({
                                height: '36px',
                                backgroundColor: "white",
                                "&:hover& td:after": {
                                    display: "none",
                                },
                                "&.MuiTableRow-root.Mui-selected": {
                                    backgroundColor: (theme) => theme.palette.primary.light70,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.light50,
                                    },
                                },
                                "&:hover": {
                                    "& td:after": {
                                        display: "none",
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.stroke,
                                },
                                '&:nth-of-type(even)': {
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                    "&:hover": {
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                },
                            })
                        })
                    }}

                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableBodyCellProps: {
                                sx: {
                                    width: "50px",
                                    "&.MuiTableCell-root": {
                                        padding: '0px 0px 0px 0px',
                                        border: "none",
                                        borderRight: '1px solid #EAEBEA'
                                    }
                                }
                            },
                            header: "",
                            size: 10,
                            grow: false,
                        },
                    }}
                    muiSearchTextFieldProps={{
                        placeholder: `Поиск`,
                        sx: {
                            paddingTop: "5px",
                            paddingBottom: "0px",
                            "& .MuiCollapse-root": {
                                borderRadius: '12px',
                                height: 40, width: 290,
                                "& .MuiSvgIcon-root": {
                                    color: "#737478"
                                },
                                '& .MuiOutlinedInput-input': {
                                    padding: 0
                                }
                            }
                        },
                        variant: 'outlined',
                    }}
                    muiToolbarAlertBannerProps={{
                        sx: {
                            backgroundColor: (theme) => theme.palette.primary.light,
                        }
                    }}
                    columns={columns}
                    data={data}
                    rowHeight={13}
                    columnSpacing={1}
                    initialState={{
                        columnVisibility: {
                            id: false,
                        },
                        isFullScreen: false,
                        density: "compact",
                        sorting: [
                            {
                                id: 'nameMaterial',
                                desc: true,
                            },],
                        grouping: ['nameMaterial'],
                        expanded: true,
                    }}
                    enableGrouping={true}
                    enableToolbarInternalActions={false}
                    onPaginationChange={(updater) => {
                        tableOptionsHandle(updater(tableOptions));
                    }}
                    rowCount={tableOptions.totalElements}
                    state={{showGlobalFilter: true, pagination: tableOptions,}}
                    selectionPadding={1}
                    selectionCss={{
                        backgroundColor: 'lightblue',
                        borderWidth: '2px',
                        borderStyle: 'solid',
                        borderColor: 'blue',
                        borderRadius: '4px',
                    }}
                    renderRowActionMenuItems={({closeMenu, row}) => menuItem.map(el => {
                        const active = (el.type === "archive" && row.original.availabilityQuantity === 0 && row.original.materialWarehouseState === "IN_STOCK") || (el.type === "add" && row.original.availabilityQuantity > 0 && !(row.original.otherIssueReserve > 0 && row.original.free === 0 && row.original.currentIssueReserve === 0))
                        return <Tooltip arrow placement="left"
                                        title={!active ? "заблокировано" : ""}>
                            <MenuItem
                                key={el.type}
                                onClick={() => {
                                    active && el.handler(row.original)
                                    closeMenu();
                                }}
                                sx={{
                                    margin: "0 8px",
                                    borderRadius: "4px",
                                    opacity: !active && 0.5,
                                    "&:hover": {backgroundColor: (theme) => theme.palette.primary.light}
                                }}
                            >
                                {el.text}
                            </MenuItem>
                        </Tooltip>
                    })}
                    localization={MRT_Localization_RU}
                    enableRowActions={true}
                    getRowId={(originalRow) => originalRow.id}
                />
                <ModalConfirm
                    title={"Подтвердить выдачу?"}
                    modalOpen={confirmIssueModalOpen}
                    handleClose={handleCloseConfirmIssue}
                    handleSubmit={handleSubmitConfirmIssue}
                    action={"Подтвердить"}
                />
                <ModalAddMaterialRetailIssuingEdge
                    open={modalAddMaterialRetailIssuingEdgeOpen}
                    onClose={handleCloseModalAddMaterialRetailIssuingEdge}
                    titleModal={"Выдать материал в количестве"}
                    availability={availability}
                    issue={issue}
                    submit={handleSubmitConfirmRetailIssue}
                />
                <ModalConfirm
                    title={"Подтвердить поместить в архив"}
                    modalOpen={confirmModalOpen}
                    handleClose={handleCloseConfirm}
                    handleSubmit={handleSubmitConfirm}
                    action={"Подтвердить"}
                />
            </div>
        );
    }
;

export default IssuingEdgeWareHouseTable;